// extracted by mini-css-extract-plugin
module.exports = {"root":"_3vaaW","SeparateBasicMenuButtonNSkin":"_2vo-y","separateBasicMenuButtonNSkin":"_2vo-y","linkElement":"_12_Z8","label":"jj-86","wrapper":"_3VfP5","borderWrapper":"_2U5Kl"};